module.exports = __webpack_public_path__ + "static/NewJune-extrabold-9b90284191072fb1bfca66f90050a0e5.woff2";